export default __webpack_public_path__ + "static/media/soja_milho.154225e4.svg";